/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * API request serializer for email verification endpoints.
 * Used for OpenAPI schema generation.
 * @export
 * @interface APIAPIEmailVerificationRequestRequest
 */
export interface APIAPIEmailVerificationRequestRequest {
    /**
     * The verification token
     * @type {string}
     * @memberof APIAPIEmailVerificationRequestRequest
     */
    token: string;
    /**
     * Password (required for invite verification)
     * @type {string}
     * @memberof APIAPIEmailVerificationRequestRequest
     */
    password?: string;
}

/**
 * Check if a given object implements the APIAPIEmailVerificationRequestRequest interface.
 */
export function instanceOfAPIAPIEmailVerificationRequestRequest(value: object): value is APIAPIEmailVerificationRequestRequest {
    if (!('token' in value) || value['token'] === undefined) return false;
    return true;
}

export function APIAPIEmailVerificationRequestRequestFromJSON(json: any): APIAPIEmailVerificationRequestRequest {
    return APIAPIEmailVerificationRequestRequestFromJSONTyped(json, false);
}

export function APIAPIEmailVerificationRequestRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIAPIEmailVerificationRequestRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'token': json['token'],
        'password': json['password'] == null ? undefined : json['password'],
    };
}

export function APIAPIEmailVerificationRequestRequestToJSON(value?: APIAPIEmailVerificationRequestRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'token': value['token'],
        'password': value['password'],
    };
}

